// extracted by css-extract-rspack-plugin
export default {"root":"root-o5hAZt","buttons":"buttons-d9XIYI","thumbs":"thumbs-rctdVO","thumbsDown":"thumbsDown-A5C0XV","thumbsUp":"thumbsUp-Wf61LY"};